'use server'

import { cookies } from 'next/headers'
import { redirect } from 'next/navigation'
import { z } from 'zod'

import { isProd } from '@/core/config/env'

import { readDb } from '../services/db.server'
import {
  VEHICLE_COOKIE,
  WISH_COOKIE,
  getWishIds,
} from '../services/catalog.server'

const COOKIE_OPTIONS = {
  httpOnly: true,
  sameSite: 'lax',
  secure: isProd,
  path: '/',
  maxAge: 60 * 60 * 24 * 180,
} as const

const selectSchema = z.object({
  vehicleId: z.string().min(1).max(60),
  group: z.enum(['charge', 'interior', 'parts', 'etc']).nullable().catch(null),
})

export async function selectVehicle(formData: FormData) {
  const parsed = selectSchema.safeParse({
    vehicleId: formData.get('vehicleId'),
    group: formData.get('group'),
  })
  if (!parsed.success) redirect('/vehicles')
  const db = await readDb()
  const vehicle = db.vehicles.find((item) => item.id === parsed.data.vehicleId)
  if (!vehicle) redirect('/vehicles')
  const store = await cookies()
  store.set(VEHICLE_COOKIE, vehicle.id, COOKIE_OPTIONS)
  const params = new URLSearchParams({ vehicle: vehicle.id })
  if (parsed.data.group) params.set('group', parsed.data.group)
  redirect(`/products?${params.toString()}`)
}

export async function clearVehicle() {
  const store = await cookies()
  store.delete(VEHICLE_COOKIE)
}

export async function toggleWish(productId: string): Promise<string[] | null> {
  const parsed = z.string().min(1).max(20).safeParse(productId)
  if (!parsed.success) return null
  const ids = await getWishIds()
  const next = ids.includes(parsed.data)
    ? ids.filter((id) => id !== parsed.data)
    : [parsed.data, ...ids].slice(0, 50)
  const store = await cookies()
  store.set(WISH_COOKIE, JSON.stringify(next), COOKIE_OPTIONS)
  return next
}
